const KEY_VOLUME = 'zion_sound_volume'
const KEY_MUTED = 'zion_sound_muted'

const DEFAULT_VOLUME = 70

export function getSoundVolume(): number {
  try {
    const raw = localStorage.getItem(KEY_VOLUME)
    if (raw == null) return DEFAULT_VOLUME
    const n = Number(raw)
    if (!Number.isFinite(n)) return DEFAULT_VOLUME
    return Math.max(0, Math.min(100, Math.round(n)))
  } catch {
    return DEFAULT_VOLUME
  }
}

export function setSoundVolume(volume: number): void {
  const v = Math.max(0, Math.min(100, Math.round(volume)))
  try {
    localStorage.setItem(KEY_VOLUME, String(v))
  } catch {
    /* ignore */
  }
}

export function isSoundMuted(): boolean {
  try {
    return localStorage.getItem(KEY_MUTED) === '1'
  } catch {
    return false
  }
}

export function setSoundMuted(muted: boolean): void {
  try {
    localStorage.setItem(KEY_MUTED, muted ? '1' : '0')
  } catch {
    /* ignore */
  }
}

/** Gain 0..1 per oscillatori / effetti in-chat. */
export function getEffectiveSoundGain(peakGain = 0.12): number {
  if (isSoundMuted()) return 0
  return peakGain * (getSoundVolume() / 100)
}
